import { pick } from 'lodash';

export const compareObj = (objectValue: object, objectSelected: object) => {
  const sorted1 = pick(objectValue, Object.keys(objectValue).sort());
  const sorted2 = pick(objectSelected, Object.keys(objectSelected).sort());

  return Object.values(sorted1).join('') === Object.values(sorted2).join('');
};
